<script>
/**
 * @overview 视频上传
 *
 * @author hqp
 */
import initCos from '../../utils/upload/tencentCos';
import store from '../../store/index';

export default {
  name: 'AppUploadVideo',

  props: {
    // 双向绑定值
    value: {
      type: String,
      default: '',
    },
    // 是否为公共资源
    common: {
      type: Boolean,
      default: false
    },
    // 提交回调信息
    type: {
      type: String,
      default: '',
    },
    // 显示加号
    icon: {
      type: Boolean,
      default: false,
    },

    // 删除
    isDelete: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      progress: 0
    }
  },

  methods: {
    uploadImg() {
      this.$refs.inputImg.click();
    },

    changeImg() {
      this.getImgData(this.$refs.inputImg.files[0]);
    },

    deleteData () {
      this.progress = 0;
      this.$refs.inputImg.value = '';
      this.$emit('on-delete');
    },

    getImgData(file) {
      const that = this,
        ssc = store.state.choicesSchool;

      if (!file) {
        return;
      }

      initCos(file, this.common ? 0 : ssc ? ssc.id : 0, res => {
        const cos = res.cos;

        that.progress = '0%';

        cos.putObject({
          Bucket: res.Bucket, /* 必须 */
          Region: res.Region, /* 存储桶所在地域，必须字段 */
          Key: `${res.md5}.${res.type}`, /* 必须 */
          StorageClass: 'STANDARD',
          Body: file, // 上传文件对象
          onProgress: function(progressData) {
            that.progress = progressData.percent.toFixed(2) * 1e3 / 10 + '%';
            console.log('onProgress', JSON.stringify(progressData));
          }
        }, function(err, data) {
          if (data) {
            that.$emit('on-success', `https://${data.Location}`, `${res.name}.${res.type}`, that.type);
            // that.icon = false;
          } else {
            that.$message.error(err);
            that.progress = 0;
          }
        });
      })
    }
  },
};
</script>

<template>
  <div class="app-upload-scale">
    <input
      ref="inputImg"
      type="file"
      accept="video/mp4,video/mov"
      style="display:none;"
      @change="changeImg">

    <div
      class="app-upload-scale__block"
      @click="uploadImg">
      <div v-if="progress" class="progress">{{progress}}</div>
      <i v-else class="icon el-icon-plus"/>
    </div>

    <div v-if="isDelete && value" class="is-delete el-icon-delete" @click="deleteData"></div>
  </div>
</template>

<style lang="postcss" scoped>
  .is-delete {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 40px;
    line-height: 40px;
    height: 40px;
    text-align: center;
    cursor: default;
  }
  .progress {
    position: absolute;
    bottom: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
.app-upload-scale{
  position: relative;
}
.app-upload-scale__block {
  cursor: pointer;
  width: 100%;
  height: 100%;
  min-height: 100px;
  border: 1px solid gainsboro;
}
.app-upload-scale__block .icon {
  display: block;
  margin: 0 auto;
  width: 100px;
  height: 100px;
  font-size: 80px;
  text-align: center;
  line-height: 100px;
  color: gainsboro;
  position: relative;
  top: calc(50% - 50px);
}
</style>



// WEBPACK FOOTER //
// src/components/AppUploadVideo/index.vue